// depenseService.js
import { depenseAPI } from './restaurantAPI';

const depenseService = {
  // Get all depenses
  async getAll(params = {}) {
    try {
      const response = await depenseAPI.getAll(params);
      console.log('Depense API Response:', response);
      return response.data;
    } catch (error) {
      console.error('Error in depenseService.getAll:', error);
      throw error;
    }
  },

  // Get single depense
  async get(id) {
    try {
      const response = await depenseAPI.getById(id);
      return response.data;
    } catch (error) {
      console.error('Error in depenseService.get:', error);
      throw error;
    }
  },

  // Create new depense
  async create(data) {
    try {
      console.log('Creating depense with data:', data);
      const response = await depenseAPI.create(data);
      return response.data;
    } catch (error) {
      console.error('Error in depenseService.create:', error);
      throw error;
    }
  },

  // Update depense
  async update(id, data) {
    try {
      const response = await depenseAPI.update(id, data);
      return response.data;
    } catch (error) {
      console.error('Error in depenseService.update:', error);
      throw error;
    }
  },

  // Delete depense
  async delete(id) {
    try {
      const response = await depenseAPI.delete(id);
      return response.data;
    } catch (error) {
      console.error('Error in depenseService.delete:', error);
      throw error;
    }
  },

  // Get statistics
  async getStats(params = {}) {
    try {
      const response = await depenseAPI.getStats(params);
      return response.data;
    } catch (error) {
      console.error('Error in depenseService.getStats:', error);
      // Fallback to manual calculation
      const depenses = await this.getAll(params);
      
      const total = depenses.reduce((sum, d) => sum + (parseFloat(d.montant) || 0), 0);
      const moyenne = depenses.length > 0 ? total / depenses.length : 0;
      
      const parType = {};
      depenses.forEach(d => {
        const type = d.type_depense || 'autre';
        if (!parType[type]) {
          parType[type] = { total: 0, count: 0 };
        }
        parType[type].total += parseFloat(d.montant) || 0;
        parType[type].count += 1;
      });
      
      return {
        total,
        moyenne,
        parType,
        count: depenses.length
      };
    }
  },

  // Get monthly summary
  async getMonthlySummary(year, month) {
    try {
      const allDepenses = await this.getAll();
      const filtered = allDepenses.filter(d => {
        const date = new Date(d.date);
        return date.getFullYear() === year && date.getMonth() === month;
      });
      
      const total = filtered.reduce((sum, d) => sum + (parseFloat(d.montant) || 0), 0);
      
      const byType = {};
      filtered.forEach(d => {
        const type = d.type_depense || 'autre';
        if (!byType[type]) {
          byType[type] = { total: 0, count: 0 };
        }
        byType[type].total += parseFloat(d.montant) || 0;
        byType[type].count += 1;
      });
      
      return {
        total,
        byType,
        count: filtered.length
      };
    } catch (error) {
      console.error('Error in depenseService.getMonthlySummary:', error);
      throw error;
    }
  },

  // Search depenses
  async search(query) {
    try {
      const response = await depenseAPI.getAll();
      const allDepenses = response.data;
      
      return allDepenses.filter(depense => {
        const searchStr = query.toLowerCase();
        return (
          depense.description.toLowerCase().includes(searchStr) ||
          depense.fournisseur?.toLowerCase().includes(searchStr) ||
          depense.notes?.toLowerCase().includes(searchStr) ||
          depense.type_depense.toLowerCase().includes(searchStr)
        );
      });
    } catch (error) {
      console.error('Error in depenseService.search:', error);
      throw error;
    }
  },

  // Export to CSV
  async exportToCSV(params = {}) {
    try {
      const depenses = await this.getAll(params);
      
      const headers = ['Date', 'Type', 'Montant', 'Description', 'Fournisseur', 'Notes'];
      const rows = depenses.map(d => [
        d.date,
        d.type_depense,
        d.montant,
        d.description,
        d.fournisseur || '',
        d.notes || ''
      ]);
      
      const csvContent = [
        headers.join(','),
        ...rows.map(row => row.join(','))
      ].join('\n');
      
      return csvContent;
    } catch (error) {
      console.error('Error in depenseService.exportToCSV:', error);
      throw error;
    }
  }
};

export default depenseService;